import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/common/Logo";
import { LegalDisclaimer } from "@/components/common/LegalDisclaimer";
import { LEGAL_PAGES } from "@/constants/legal";

export const MarketingFooter = () => (
  <footer className="border-t bg-secondary/30">
    <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6">
      <div className="flex flex-col items-start justify-between gap-8 lg:flex-row">
        <div className="max-w-sm">
          <Logo />
          <p className="mt-3 text-sm text-muted-foreground">Smarter, compliance-first booking risk checks for Australian short-stay hosts.</p>
        </div>
        <div className="grid grid-cols-2 gap-10 text-sm sm:grid-cols-3">
          <div className="space-y-2.5">
            <p className="font-medium">Product</p>
            <a href="/#how" className="block text-muted-foreground hover:text-foreground">How it works</a>
            <Link to="/pricing" className="block text-muted-foreground hover:text-foreground">Pricing</Link>
            <a href="/#faq" className="block text-muted-foreground hover:text-foreground">FAQ</a>
          </div>
          <div className="space-y-2.5">
            <p className="font-medium">Legal &amp; compliance</p>
            {LEGAL_PAGES.map((p) => (
              <Link
                key={p.slug}
                to={p.path}
                className="block text-muted-foreground hover:text-foreground"
                data-testid={`footer-${p.slug}-link`}
              >
                {p.footerLabel}
              </Link>
            ))}
          </div>
          <div className="space-y-2.5">
            <p className="font-medium">Account</p>
            <Link to="/login" className="block text-muted-foreground hover:text-foreground">Log in</Link>
            <Link to="/signup" className="block text-muted-foreground hover:text-foreground">Sign up</Link>
          </div>
        </div>
      </div>
      <div className="mt-10 border-t pt-6">
        <LegalDisclaimer compact />
        <p className="mt-4 text-xs text-muted-foreground">© {new Date().getFullYear()} HostGuard Australia. All rights reserved.</p>
      </div>
    </div>
  </footer>
);
